import { Controller } from "@hotwired/stimulus";
/**
 * Dummy counter controller
 */
export default class default_1 extends Controller {
    connect() {
        this.update("");
        if (this.hasInputIdValue) {
            this.update(this.obtenerValorDeInput(this.inputIdValue));
        }
    }
    updateForInput(event) {
        this.update("");
        if (this.hasInputIdValue) {
            this.update(this.obtenerValorDeInput(this.inputIdValue));
        }
        else if (event.params.inputId) {
            this.update(this.obtenerValorDeInput(event.params.inputId));
        }
    }
    update(value) {
        this.element.textContent = `${this.hasPrefijoValue ? this.prefijoValue : ""}${value.length}`;
    }
    obtenerValorDeInput(inputId) {
        const input = document.getElementById(inputId);
        if (input && "value" in input && typeof input.value === "string") {
            return input.value;
        }
        return "";
    }
}
default_1.values = {
    prefijo: String,
    inputId: String,
};
//# sourceMappingURL=length_display_controller.js.map